import { safeDefineElement } from '@/scripts/core/global'
import { StickyHeader } from '@/scripts/theme/sticky-header'
import { UcoastVideo } from '@/scripts/core/ucoast-video';
import { ProductSlider } from '@/scripts/theme/product-slider'
import { MultiProductSlider } from '@/scripts/theme/multi-product-slider'
import { TestimonialsSlider } from '@/scripts/theme/testimonials-slider'
import { UgcSlider } from '@/scripts/theme/ugc-slider'
import { UgcPopup } from '@/scripts/theme/ugc-popup'
import { ProductInfo } from '@/scripts/product/product-info'
import { ProductForm } from '@/scripts/product/product-form'
import { VariantSelects } from '@/scripts/theme/variant-selects'
import { CartVariantSelect } from '@/scripts/theme/cart-variant-select'
import { VariantRadios } from '@/scripts/theme/variant-radios'
import { TabSlider } from '@/scripts/theme/tab-slider'
import { StickyColumns } from '@/scripts/theme/sticky-columns'
import { ProductStickyNav } from '@/scripts/theme/product-sticky-nav'
import { BaSlider } from '@/scripts/interactive-defer/ba-slider'
import { UcoastSelect } from '@/scripts/theme/ucoast-select'
safeDefineElement(UcoastVideo)
safeDefineElement(StickyHeader)
safeDefineElement(ProductSlider)
safeDefineElement(MultiProductSlider)
safeDefineElement(TestimonialsSlider)
safeDefineElement(BaSlider)
safeDefineElement(UgcSlider)
safeDefineElement(UgcPopup)
safeDefineElement(ProductInfo)
safeDefineElement(ProductForm)
safeDefineElement(VariantSelects)
safeDefineElement(CartVariantSelect)
safeDefineElement(VariantRadios)
safeDefineElement(TabSlider)
safeDefineElement(StickyColumns)
safeDefineElement(ProductStickyNav)
safeDefineElement(UcoastSelect)
